import { Pivot, PivotItem } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import classNames from 'classnames';
import { get } from 'lodash';
import { FunctionComponent, useState } from 'react';
import { useUserPermissions } from '../../hooks/useUserPermissions';
import { MIDAS_MODULES } from '../../models/EnumMidasModules';
import ModuleTitleComponent from '../../shared/ModuleTitleComponent';
import { getMenuOptionById } from '../Nav/consts';
import { maintainTabs } from './consts';
import styles from './Maintain.module.scss';

interface MaintainComponentProps {
  value?: any;
};

const MaintainComponent: FunctionComponent<MaintainComponentProps> = () => {

  const [isLoading, { toggle: toggleShowLoading }] = useBoolean(false);
  const [currentTab, setCurrentTab] = useState(maintainTabs.maintainProduct.name);

  const { getPermissionsByAccessKey } = useUserPermissions();

  const handleLinkClick = (item?: PivotItem) => {
    const newTab = get(item, 'props.itemKey', '');
    setCurrentTab(newTab);
  };

  const getTabId = (itemKey: string) => `ShapeColorPivot_${itemKey}`;

  const renderTab = (TabComponent: FunctionComponent) => {
    if (TabComponent) return <TabComponent />;
  };

  const moduleInfo = getMenuOptionById(MIDAS_MODULES.MAINTAIN);

  return (
    <>
      <div className="ms-Grid record-keeping-container mainContainer" dir="ltr">
        <ModuleTitleComponent moduleInfo={moduleInfo} />
        <div className='ms-Grid-row'>
          <div className={classNames(
            'ms-Grid-col',
            'ms-lg12',
            'tabulatorWrapper',
            styles.headerTabsContainer,
          )}>
            <Pivot
              aria-label='Separately Rendered Content Pivot Example'
              className='pivot-gy-colors'
              selectedKey={currentTab}
              onLinkClick={handleLinkClick}
              getTabId={getTabId}
              linkFormat='tabs'
              linkSize='large'
            >
              {Object.values(maintainTabs).map(({ accessKey, name, component }, index) =>
                getPermissionsByAccessKey(accessKey)?.isAccess && (
                  <PivotItem headerText={name} key={index} itemKey={name}>
                    <div className={styles.tabsContainer}>{renderTab(component)}</div>
                  </PivotItem>
                ))}
            </Pivot>
          </div>
        </div>
      </div>
    </>
  );
};

export default MaintainComponent;